import React from 'react';
import { Header } from '../components/global/header';
import { Login } from '../components/auth/login';
import { Footer } from '../components/global/footer';

const LoginPage = () => {
  return (
    <div>
      <Header />
      <Login />
      <Footer />
    </div>
  );
};

export default LoginPage;
